import React from "react"
import Head from "next/head"
import SeoContext from "@components/Layout/SeoContext"

interface HelmetProps {
  title: string
  description?: string
  image?: string
  meta?: React.ReactNode
  children?: React.ReactNode
}

const Helmet: React.FC<HelmetProps> = ({
  title,
  description = "",
  image,
  meta,
  children,
}) => {
  const { seoData }: any = React.useContext(SeoContext)

  const metaData = {
    title: title || seoData?.title || "SKB Cases",
    description: description || seoData?.description,
    image: image || seoData?.image || seoData?.logo,
  }

  return (
    <Head>
      <meta charSet="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <link rel="icon" href="/favicon.png" />
      <link rel="shortcut icon" href="/favicon.png" />
      <title>{title}</title>
      <meta name="title" content={metaData.title} />
      <meta name="description" content={metaData.description} />
      <meta property="og:title" content={metaData.title} />
      <meta property="og:description" content={metaData.description} />
      <meta property="og:image" content={metaData.image} />
      {meta}
      {children}
    </Head>
  )
}

export default Helmet
